export default {
    infomationTip: '免責聲明：以上內容僅供參考，不作為投資決策依據。投資有風險，入市需謹慎。',
    infomationThirdTip:
        '免責聲明：以上信息及數據來源自第三方，平台無法核實信息的真實性、準確性、完整性及原創性等。星財富轉載僅供投資者參考，並不代表復星國際證券有限公司及其控股或附屬公司的觀點，不構成任何投資建議，您自己承擔因信賴或只用第三方信息而導致的任何損失。投資有風險，入市需謹慎。',
    infomationStarWealthTip: '免責聲明：本內容由復星財富國際控股有限公司全資子公司復星國際證券有限公司基於人工智慧分析整合後生成，數據來源為互聯網公開信息。復星財富國際控股有限公司及其全資子公司復星國際證券有限公司及／或其關聯公司將竭力但卻不能保證以上內容之準確和可靠，亦不會承擔因任何不準確或遺漏而引起的任何損失或損害。本文內容僅供參考，不作為實際操作建議，也不構成及不應被視為買賣任何證券或投資的要約或該要約的招徠或懇求。投資者應自行核實相關信息並獨立判斷，所有交易決策需結合個人風險承受能力，市場有風險，投資需謹慎，過往表現不預示未來結果。<br/><br/>免責聲明：以上內容僅供參考，不作為投資決策依據。投資有風險，入市需謹慎。',
    infomationStock: '相關標的',
    infomationNews: '相關資訊',
    informationTitle: '資訊詳情',
    flashNews: '快訊',
    newwork: '網路連接超時，請稍後重試',
    text01: '伴您財富乘長 ',
    text02: '很抱歉，您查看的內容不存在',
    downloadMsg: '下載',
    openAppMsg: 'APP內打開',
    reading: '閱讀',
    readingNum: '閱讀量',
    disclaimer: '以上信息及數據來源自第三方，本平台無法核實信息的真實性、準確性、完整性及原創性等。以上轉載內容僅供參考，不作為本平台之立場及投資決策依據。投資有風險，入市需謹慎。',
    disclaimer4AI: '本內容由本平台基於人工智能分析整合後生成，數據來源為互聯網公開信息。本平台竭力但不能保證上述內容準確和可靠。以上內容僅供參考，不作為投資決策依據。投資有風險，入市需謹慎。',
    night: '夜盤',
    minutesAgo: '{n}分鐘前',
    loading: '加載中...',
}
